import { Link } from "react-router-dom";
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import  vdc_logo  from "./vdc_logo.png";

const Dashboard = () => {
  return (
    <div className="wrapper">
      <Sidebar />
      <main className="main-content content-page ">
        <div className="position-relative ">
          <Navbar /></div>
        <div class="content-inner container-fluid pb-0" id="page_layout">
          <div>
            <div className="row">
              <div className="col-sm-12">
                <div className="row">
                <div className="col-md-6 col-lg-3">
                    <div className="card">
                      <div
                        className="card-body p-0 rounded"
                        style={{
                          background: `url(${vdc_logo}) no-repeat center center`,
                          backgroundSize: "contain",
                          minHeight: "152px",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
